import { NavigateFunction } from "react-router-dom";

export const performRedirect = (
  basePath: string,
  redirectPath: string | null,
  navigate: NavigateFunction
) => {
  if (redirectPath) {
    // Ensure the path starts with a slash for absolute navigation
    const finalPath = redirectPath.startsWith("/")
      ? redirectPath
      : `/${redirectPath}`;
    navigate(finalPath, { replace: true });
  } else {
    navigate(basePath, { replace: true });
  }
};
